export const FOLDER_KEYS = [
  'connector_views',
  'power_distribution',
  'vehicle_views',
  'visual_aid',
  'device_layout',
]

export const emptyFolders = () => ({
  connector_views: [],
  power_distribution: [],
  vehicle_views: [],
  visual_aid: [],
  device_layout: [],
})

export const formatFolderLabel = (key) =>
  key
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
